import { createAPI } from "../apisServer";
import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqTaxaEntrega = {
	list: async function (paramUrlComponent, paramValueUrlComponent, active, page) {
		return apiServer
			.get("portal/v1/taxa-entrega", {
				headers: { banco },
				params: {
					param: paramUrlComponent,
					paramValue: paramValueUrlComponent,
					active: active,
					page: page,
					perpage: 15,
				},
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},
	listID: async function (id) {
		return apiServer
			.get(`portal/v1/taxa-entrega/${id}`, {
				headers: { banco },
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v1/taxa-entrega", data, {
				headers: { banco },
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},
	remove: async function (id) {
		return apiServer
			.delete(`portal/v1/taxa-entrega/${id}`, {
				headers: { banco },
			})
			.then((response) => response)
			.catch((error) => {
				throw error;
			});
	},
};

export default reqTaxaEntrega;
